import styles from './About.module.css';

export default function AboutSection({title,slogan, text, link, image, sectionRef}) {

    return (
      <section className={styles['about-section']} ref={sectionRef}>
        <div className="container-lg">
          <div className="row align-items-center">
            <div className="col-12 col-md-10 mx-auto">
              <div className="row justify-content-center">
                 <div className="col-7 col-sm-5 col-md-3">
                  <div className={styles['about-image']} >
                    <img src={image.url} width={image.width} height={image.height} alt={title} />
                  </div>
                </div>
                <div className="col-12 col-md-8">
                  <div className={styles['about-content']}>
                    <div className={styles['about-head']}>
                        <h1 className={styles['about-title']}>{title}</h1>
                        <span className={styles['about-top-title']}>{slogan}</span>
                    </div>
                    <div className={styles['about-text']}>
                      <p>{text}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
}